import isUrl from "is-url"

export function isValidLegislationUrl(url) {
    if (!url?.trim()) return false
    const normalized = /^https?:\/\//i.test(url) ? url : `https://${url}`
    return isUrl(normalized)
}

export function isLegislationRedirectUrl(url) {
    if (!url?.trim()) return false
    const normalized = /^https?:\/\//i.test(url) ? url : `https://${url}`
    try {
        const { host, pathname } = new URL(normalized)
        return /(^|\.)facilities-iq\.com$/i.test(host) && /^\/legislation\//i.test(pathname)
    } catch {
        return false
    }
}

export function validateAuthoringLegislationUrl(url) {
    if (!url?.trim()) throw new Error("A URL is required.")
    if (!isValidLegislationUrl(url)) throw new Error("The URL provided is not valid.")
    if (isLegislationRedirectUrl(url)) {
        throw new Error("That's an SFG20 redirect link — enter the destination web page it should point to instead.")
    }
}
